/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Pricing_Faq_Show_MoreInputs */



/**
* | output |
* | --- |
* | "Show {count} more sections" |
*
* @param {Pricing_Faq_Show_MoreInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_faq_show_more = /** @type {((inputs: Pricing_Faq_Show_MoreInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq_Show_MoreInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} weitere Abschnitte anzeigen`)
	return /** @type {LocalizedString} */ (`Show ${i?.count} more sections`)
});